import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from '@nosto/preact'
import { useEffect, useState } from 'preact/hooks'

export default ({ facet, setShowFilters, clickedFacet, setClickedFacet }) => {
    const {
        min,
        max,
        range,
        updateRange
    } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(isSelected)

    useEffect(() => {
        if (clickedFacet) {
            setActive(facet.id === clickedFacet.id);
            setClickedFacet(null);
        }
    })

    useEffect(()=>{
        document.querySelectorAll(".ns-handle").forEach(el => el.setAttribute("tabindex","-1"))
        document.querySelectorAll(".ns-tip").forEach(el => el.setAttribute("aria-hidden","true"))
    })

    return (
        <li class={`ns-sidebar-dropdown ${active ? 'ns-active' : ''}`}>
            <button
                class="notabutton ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-p-4 ns-facet-name"
                onClick={() => {
                    setActive(!active)
                }}
                aria-controls={`FacetPanel-${facet.field}`}
            >
                <h2 class="filter-group__heading__text body-style">
                    {facet.name}
                </h2>
                {/* <i class="ns-icon ns-icon-arrow ns-absolute"></i> */}
                {/* <img class="ns-icon ns-icon-arrow" src="https://d21m4dsqdd3b9h.cloudfront.net/shopify-61071458562/onsiteContent/16957372481250.3703686483307296" /> */}
                <span class="ns-icon ns-icon-arrow">
                    <svg class="svg-icon" viewBox="0 0 20 20">
                        <path fill="none" d="M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0
                    l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109
                    c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483
                    c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788
                    S1.293,9.212,1.729,9.212z"></path>
                    </svg>
                </span>
            </button>
            <div class="ns-sidebar-submenu ns-px-4" id={`FacetPanel-${facet.field}`} hidden={!active}>
                <div class="ns-d-flex ns-justify-content-between ns-font-4 ns-pb-4">
                    <div class="ns-col-6 flex-shrink-1 ns-mr-2">
                        <label for={`ns-${facet.id}-min`} class="ns-form-label">
                            Min.
                        </label>
                        <input
                            type="number"
                            class="ns-input-field ns-d-block"
                            id={`ns-${facet.id}-min`}
                            value={range[0]}
                            min={min}
                            max={max}
                            onChange={(e) => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                        />
                    </div>
                    <div class="ns-col-6 flex-shrink-1">
                        <label for={`ns-${facet.id}-max`} class="ns-form-label">
                            Max.
                        </label>
                        <input
                            type="number"
                            class="ns-input-field ns-d-block"
                            id={`ns-${facet.id}-max`}
                            value={range[1]}
                            min={min}
                            max={max}
                            onChange={(e) => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                                setShowFilters(false)
                            }}
                        />
                    </div>
                </div>
                <RangeSlider tabindex="-1" id={facet.id} />
            </div>
        </li>
    )
}
